import React from "react";
import { Button2, VerticalSwiperV2 } from "../../components";
import styles from "./DealComparison.module.scss";
import bgVideos from "../../assets/images/DealComparison.mp4";
import { DEAL_COMPARISON_FORM, KNOWLEDGECENTER } from "../../routes/constants";
import CLARITY_IMG from "../../assets/images/clarify.webp";
import CONTROL_IMG from "../../assets/images/compare.webp";
import PERFORMANCE_IMG from "../../assets/images/MusicPerformance.webp";
import { GetIframeVideo } from "../../routes/constants";
import SnapSection from "../../components/SnapSection/SnapSection";
import { ReactComponent as DoubleArrow } from "../../assets/SVGs/double-chevron-right.svg";
import { ReactComponent as PlayButton } from "../../assets/SVGs/play.svg";
import FeaturedVideo from "../../sections/FeaturedVideo";
import { motion } from "motion/react"
// when we have more than one testimonial: import { LabelTestimonials } from "../../sections";
import TESTIMONIAL_IMG from "../../assets/headshots/kingUndergroundSquare.webp";
import { ReactComponent as KULogo } from "../../assets/partnerLogos/KingUndergroundLogo.svg";
import { useReducedMotion } from "framer-motion";
import { CTASection } from "../../sections";

function DealComparison () {

    const reduced = useReducedMotion();

    return (
      <div id="DealComparison" className={styles.container}>
        <SnapSection>
            <div className={styles.videoHeader}>
                <video autoPlay={!reduced} loop playsInline muted alt="Abstract video of data points interweaving and making triangle shapes." className={styles.video}>
                <source src={bgVideos} type="video/mp4" />
                </video>
                <div id="landing" className={styles.landing}>
                    <div className={styles.heading}>
                        <h1 className={styles.titleCtn}>
                            <span className={styles.primary}>Compare Offers.</span>
                            <span className={styles.secondary}>Make the Right Choice.</span>
                        </h1>
                        <p>Compare. Clarify. Choose. </p>
                    </div>
                    <div className={styles.landingActions}>
                        <FeaturedVideo className={styles.actionButton} video="https://www.youtube-nocookie.com/embed/L6VlcSYsWgk?si=I5WNLellwutYfMG-&rel=0&autoplay=1&mute=1&modestbranding=1">
                            <Button2 white outline className={styles.actionButton}><PlayButton/><p>How it Works</p> </Button2>
                        </FeaturedVideo>
                        <Button2 light to={DEAL_COMPARISON_FORM} className={styles.actionButton}><p>Get Started</p> <DoubleArrow/></Button2>
                    </div>
                </div>
            </div>
        </SnapSection>
        <VerticalSwiperV2 light>
          <div className={styles.videoSlide}>
            <div className={styles.description}>
              <h2>Compare</h2>
              <p>Share offers you've received and we'll break down the key elements of each deal and compare them to offers from our funding network.</p>
            </div>
            <div className={styles.stackedImages}>
              <img className={styles.content} src={CONTROL_IMG} alt=""/>
              <img className={styles.performance} src={PERFORMANCE_IMG} alt=""/>
            </div>
          </div>
          <div className={styles.videoSlide}>
            <div className={styles.description}>
              <h2>Clarify</h2>
              <p>See how your cashflows, costs and recoupment compare over time, and the pros and cons of each deal depending on how your music performs.</p>
            </div>
            <div className={styles.stackedImages}>
              <img className={styles.content} src={CLARITY_IMG} alt=""/>
              <img className={styles.performance} src={PERFORMANCE_IMG} alt=""/>
            </div>
          </div>
          <div className={styles.videoSlide}>
            <div className={styles.description}>
              <h2>Choose</h2>
              <p>Choose the right deal for you, whether it's from beatBread, a partner, or even a competitor.</p>
            </div>
            <GetIframeVideo
              className={styles.content}
              url="https://youtu.be/L6VlcSYsWgk?si=I5WNLellwutYfMG-"
              loading="lazy"
              themeplay="true"
            />
          </div>
        </VerticalSwiperV2>
        <SnapSection>
          <motion.div className={styles.distributorContainer} initial={{ opacity: 0, scale: 0.75, transition: { duration: 0.8, ease: [0, 0.71, 0.2, 1.01],}, }} whileInView={{ opacity: 1, scale: 1, transition: { duration: 0.8, ease: [0, 0.71, 0.2, 1.01],}}}>
          <div className={styles.distributorContent}>
            <div className={styles.distributorTitle}>
              <h2>Success Stories</h2>
              <p>Hear from some of the many labels & artists who have used beatBread to make the right choice.</p>
            </div>
            <Button2 to={KNOWLEDGECENTER} className={styles.apply} light>
              <p>Read More</p>
              <DoubleArrow/>
            </Button2>
          </div>
          <div className={styles.testimonial}>
            <div className={styles.imgWrap}>
              <div className={styles.testimonialImg} style={{backgroundImage: `url(${TESTIMONIAL_IMG})`}}/>
              <p className={styles.quote}>"I had what I thought were two quite attractive distribution offers. After seeing the output of beatBread's Deal Comparison Tool, I realized that there were several scenarios where I could have ended up strapped for cash. Although I didn't take beatBread's offer in the end, I took funding from one of their Network Partners.  Very glad I found beatBread when I did!"</p>
            </div>
            <div className={styles.footer}>
              <div className={styles.footerText}>
                <h3>Dan Englander</h3>
                <h4>KingUnderground &#40;England&#41;</h4>
              </div>
              <KULogo/>
            </div>
          </div>
        </motion.div>
      </SnapSection>
      <CTASection title={<>Compare Offers. <br/> Make the Right Choice.</>} subtitle="Compare. Clarify. Choose." primaryButton={DEAL_COMPARISON_FORM} secondaryVideo="https://www.youtube-nocookie.com/embed/L6VlcSYsWgk?si=I5WNLellwutYfMG-?rel=0&autoplay=1&mute=1&modestbranding=1" primaryButtonLabel={<><p>Get Started</p> <DoubleArrow/></>} secondaryButtonLabel={<><PlayButton/><p>How it Works</p></>}/>
    </div>
  );
}

export default DealComparison;
